<template>
    <div>
        <div class="tuiguangListShow" v-for="(item,index) in tuiguangListData" :key="index" >
            <div class="tuiguangList">
                <div class="tuiguangListTop">
                    <p class="shouyiTitle">{{item.goodsName}}</p>
                    <p class="shouyiMoney">+¥{{item.commissionMoney}}</p>
                    </div>

                    <div class="tuiguangDetailInforList">
                    
                    <p  class="tgDetailField">
                        <span>下单时间：</span>
                        <font class="commonWidth200">{{item.paidTime && item.paidTime}}</font>
                        <span class="marginLeft80">订单状态：</span>
                        <!--0 未支付 2 已支付  9 已关闭-->
                        <font class="orderStatusColor">{{item.orderStatus === 0 ? '未支付' : item.orderStatus === 2 ? '已支付' : '已关闭'}}</font>
                    </p>                               

                    <p  class="tgDetailField">
                        <span>实付金额：</span>
                        <font class="commonWidth200">{{item.orderRealPay}}</font>
                        <span class="marginLeft80 maijiaText">买<font></font>家：</span>
                        <font class="maijieDetailInfor">{{item.orderUserName}}</font>
                    </p>                               

                    <p  class="tgDetailField" v-if="currentActiveName != 'zhijietuiguang'">
                        <span>代理商名称：</span>
                        <font class="textCut">{{item.agentName}}</font>
                    </p>                               

                    <p  class="tgDetailField">
                        <span>佣金比例：</span>
                        <font>{{item.commissionRate}}%</font>
                    </p>                               

                    </div>
            </div>

        </div>
     </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant';


export default {
    name: "commonTuiguangList",
    props: ['tuiguangListData', 'currentActiveName'],
    data () {
        return {
            listData: [],



        };
    },
    components: {
        
    },

    computed: {
    },


    created(){
       
    },

    mounted(){
       
    },
    destroyed(){
        
    },

    methods: {

    

       
    },



}

</script>


<style  scoped>
 @import "../asset/css/agentManage.css";
</style>

